import { Transition } from "@mantine/core";
import type { JSX, SVGProps } from "react";

interface AnimatedDoubleCheckMarkProps extends SVGProps<SVGSVGElement> {
    double?: boolean;
    tooltipText?: string;
}

export function AnimatedDoubleCheckMark({
    double = false,
    tooltipText,
    ...props
}: AnimatedDoubleCheckMarkProps): JSX.Element {
    const fill = props.fill ?? "var(--mantine-color-success-5)";
    return (
        <svg width="19" height="15" viewBox="0 0 19 15" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
            {tooltipText && <title>{tooltipText}</title>}
            <path
                d="M17.6458 1.63867L8.79804 13.3053L5.26133 9.97601"
                stroke={fill}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Transition mounted={double} transition="slide-left" duration={250} timingFunction="ease">
                {(transitionStyle) => (
                    <>
                        <path
                            d="M7.35587 10.062L13.7436 1.63867"
                            stroke={fill}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={transitionStyle}
                        />
                        <path
                            d="M1.35912 9.97534L4.89583 13.3053L5.68704 12.2627"
                            stroke={fill}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={transitionStyle}
                        />
                    </>
                )}
            </Transition>
        </svg>
    );
}
